export function formatPhoneNumber(phoneNumber: string) {
  const cleanedNumber = phoneNumber.replace(/\D/g, '')
  let formattedNumber = '+7'

  if (cleanedNumber.length > 1) {
    formattedNumber += ` ${cleanedNumber.substr(1, 3)}`
  }
  if (cleanedNumber.length > 4) {
    formattedNumber += ` ${cleanedNumber.substr(4, 3)}`
  }
  if (cleanedNumber.length > 7) {
    formattedNumber += ` ${cleanedNumber.substr(7, 2)}`
  }
  if (cleanedNumber.length > 9) {
    formattedNumber += ` ${cleanedNumber.substr(9, 2)}`
  }
  if (cleanedNumber.length > 11) {
    formattedNumber += ` ${cleanedNumber.substr(11)}`
  }

  return formattedNumber
}
